import React, { useEffect } from 'react';

const ValuationForm = () => {
  useEffect(() => {
    const ZAPIER_URL = "https://hooks.zapier.com/hooks/catch/24147191/u6t6dh2/";
    const THANK_YOU_URL = "https://hvacbizbroker.com/thank-you";

    function serializeForm(form) {
      const data = {};
      new FormData(form).forEach((v, k) => data[k] = v);
      return data;
    }

    document.addEventListener("DOMContentLoaded", function () {
      const form = document.querySelector("#valuation");
      const statusEl = document.querySelector("#val-status");
      if (!form) return;

      form.addEventListener("submit", async function (e) {
        e.preventDefault();
        if (statusEl) statusEl.textContent = "Submitting...";

        // Honeypot check
        const hp = form.querySelector('input[name="contact_homepage_url"]');
        if (hp && hp.value) {
          if (statusEl) statusEl.textContent = "Submission blocked.";
          return;
        }

        // Minimal required validation
        const required = ["name","email","phone","company_name","annual_revenue","location"];
        for (const k of required) {
          const el = form.querySelector(`[name="${k}"]`);
          if (!el || !el.value.trim()) {
            if (statusEl) statusEl.textContent = "Please complete all required fields.";
            return;
          }
        }

        const payload = serializeForm(form);

        try {
          await fetch(ZAPIER_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
            mode: "cors",
            keepalive: true
          });
          window.location.href = THANK_YOU_URL;
        } catch (err) {
          // Fallback redirect so user still sees confirmation
          window.location.href = THANK_YOU_URL;
        }
      });
    });
  }, []);

  return (
    <section id="valuation" className="py-20 bg-gradient-to-br from-gray-900 to-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <section id="valuation-form" style={{maxWidth:"760px", margin:"0 auto", padding:"20px"}}>
          <h2 className="text-3xl font-bold mb-6 text-center">Get Your Free Valuation</h2>
          <form id="valuation" noValidate>
            <input type="hidden" name="form_name" value="valuation" />

            <label className="block mb-4">Name*<br/>
              <input type="text" name="name" required className="w-full px-4 py-2 mt-1 text-gray-900 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
            </label>

            <label className="block mb-4">Email*<br/>
              <input type="email" name="email" required className="w-full px-4 py-2 mt-1 text-gray-900 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
            </label>

            <label className="block mb-4">Phone*<br/>
              <input type="tel" name="phone" required className="w-full px-4 py-2 mt-1 text-gray-900 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
            </label>

            <label className="block mb-4">Company Name*<br/>
              <input type="text" name="company_name" required className="w-full px-4 py-2 mt-1 text-gray-900 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
            </label>

            <label className="block mb-4">Annual Revenue*<br/>
              <input type="text" name="annual_revenue" placeholder="$3,000,000" required className="w-full px-4 py-2 mt-1 text-gray-900 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
            </label>

            <label className="block mb-4">EBITDA<br/>
              <input type="text" name="ebitda" placeholder="$600,000" className="w-full px-4 py-2 mt-1 text-gray-900 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
            </label>

            <label className="block mb-4">Location* (City, State)<br/>
              <input type="text" name="location" required className="w-full px-4 py-2 mt-1 text-gray-900 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
            </label>

            {/* Honeypot */}
            <div aria-hidden="true" style={{position:"absolute", left:"-9999px", top:"-9999px", height:0, overflow:"hidden"}}>
              <input type="text" name="contact_homepage_url" tabIndex="-1" autoComplete="off" />
            </div>

            <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-300 mt-4">Get My Free Valuation</button>
            <p id="val-status" className="mt-4 text-center text-white"></p>
          </form>
        </section>
      </div>
    </section>
  );
};

export default ValuationForm;